import { withStyles } from '@material-ui/core';
import Card from './Card';
import styles from './styles';

export default withStyles(styles)(Card);
